import { kaiTypography, type KaiTypographyName } from '../core/tokens';

const REM_BASE_PX = 10; // matches the 10px-equivalent :root base applied by web consumers

export const pxToRem = (px: number): string => `${px / REM_BASE_PX}rem`;

export type KaiWebTextStyle = Omit<(typeof kaiTypography)[KaiTypographyName], 'fontSize'> & {
  fontSize: string;
};

export const kaiTypographyWeb: Record<KaiTypographyName, KaiWebTextStyle> = Object.fromEntries(
  (Object.entries(kaiTypography) as [KaiTypographyName, (typeof kaiTypography)[KaiTypographyName]][]).map(
    ([name, style]) => [name, { ...style, fontSize: pxToRem(style.fontSize) }],
  ),
) as Record<KaiTypographyName, KaiWebTextStyle>;
